/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useState } from 'react'
import ActionsMenuBig from '../../../components/shared/ActionsMenuBig'
import { useServiceContext } from '../../../root'
import { ModalImport } from '../../../components/modals/ModalImport'

interface PageMenuProps {
  onAddWatermark: () => void
  onExportStart?: () => void
  onExportEnd?: () => void
}

const PageMenu: React.FC<PageMenuProps> = ({ onAddWatermark, onExportStart, onExportEnd }) => {
  const context = useServiceContext()
  const { translate } = context.service.filter
  const { toast } = context.service
  const [showImportModal, setShowImportModal] = useState(false)

  const handleExport = async () => {
    try {
      // Start loading
      if (onExportStart) {
        onExportStart()
      }

      // Export all watermarks using WATERMARKS entity constant
      await context.api.settings.exportSettingsData('WATERMARKS', undefined, undefined, translate)
    } catch (error) {
      toast.error(translate('SETTINGS_IMPORT_FAIL'))
    } finally {
      // End loading
      if (onExportEnd) {
        onExportEnd()
      }
    }
  }

  const settings = {
    menuId: 'page',
    items: [
      {
        value: 'WATERMARKS_ADD_WATERMARK_COMMAND',
        action: () => {
          onAddWatermark()
        }
      },
      {
        value: 'WATERMARKS_IMPORT',
        action: () => {
          setShowImportModal(true)
        }
      },
      {
        value: 'WATERMARKS_EXPORT',
        action: handleExport
      }
    ]
  }

  return (
    <div>
      <ActionsMenuBig {...settings} />
      {showImportModal && (
        <ModalImport
          importType={context.constant.system.settings.entities.WATERMARKS}
          show={showImportModal}
          onClose={() => {
            setShowImportModal(false)
          }}
        />
      )}
    </div>
  )
}

export default PageMenu
